module.exports = __webpack_public_path__ + "img/patrn-2.d4fa0f2f.png";